import React from "react";
import "../css/AboutMe.css";
// import aboutImage from "../images/aboutImage.jpg";
import contactImage from "../images/contactImage.jpeg";
import { Avatar } from "@mui/material";
import fiverLogo from "../images/fiverLogo.png";

function AboutMe() {
  return (
    <div className="aboutSec">
      {/* <img src={contactImage} alt="" srcset="" /> */}

      {/* <div className="aboutRow">
        <img className="" src={contactImage} alt="" srcset="" />
      </div> */}

      <div className="aboutColumn">
        <h1>About Me</h1>
        <p>
          Hey im Unais Self-Taught Software Engineer and im currently working as
          a freelancer but im looking for a good job,Good knowledge in computer
          development software development including Android Development /
          JAVA,Kotlin and Full Stack / MERN Web Developer and Python / Django
          Developer and React Native Android/IOS Developer -Skilled in working
          with database management tools such as MongoDB.MySQL -Highly organized
          with exceptional commitment to task completion and quality assurance
          when working with computer software programs. -Committed to delivering
          company objectives to projects and results to customers and improving
          each version of software I engage with. -Ability to solve complex
          problems successfully with minimal guidance or help using a logical
          reasoning technique and a strong attention to detail.
        </p>

        <div className="socialMediaSec">
          <div className="logoCard">
          <img
              src="https://cdn-icons-png.flaticon.com/512/5968/5968764.png"
              alt=""
              srcset=""
            />
          </div>

          <div className="logoCard">
            <img
              src="https://cdn-icons-png.flaticon.com/512/145/145807.png"
              alt=""
              srcset=""
            />
          </div>
        
        <div className="logoCard">
        <img src={fiverLogo} alt="" srcset="" />
        </div>
        </div>

        <a
          target="_blank"
          className="hireBtn"
          href="https://www.fiverr.com/devunais?public_mode=true"
        >
          Hire Me
        </a>
      </div>
    </div>
  );
}

export default AboutMe;
